import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanyDashboardComponent } from './components/company-dashboard/company-dashboard.component';
import { CompanyDetailsComponent } from './components/company-details/company-details.component';
import { CompanyDocumentsComponent } from './components/company-documents/company-documents.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CompanyDocumentsPageComponent } from './components/company-documents-page/company-documents-page.component';
import { RouterModule } from '@angular/router';
import { CommonsModule } from '../common/commons.module';
import { DocumentsModule } from '../documents/documents.module';
import { SharedModule } from '../shared/shared.module';
import { CompanyDocumentDetailsPageComponent } from './components/company-document-details-page/company-document-details-page.component';
import { OperativesModule } from '../operatives/operatives.module';
import { ObservationModule } from '../observations/observation.module';
import { CompanyOperativesComponent } from './components/company-operatives/company-operatives.component';
import { CompanyDetailsModalComponent } from './components/company-details-modal/company-details-modal.component';
import { CompaniesDocumentsListComponent } from './components/companies-documents-lists/companies-documents-list.component';
import { RippleModule } from 'primeng/ripple';
import { CompanyOperativeTrainingRecordsComponent } from './components/company-operative-training-records/company-operative-training-records.component';
import { CompanyOperativeTrainingRecordsPageComponent } from './components/company-operative-training-records-page/company-operative-training-records-page.component';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { CompanyOptInModalComponent } from './components/company-opt-in-modal/company-opt-in-modal.component';
import { CardModule } from 'primeng/card';
import { TabViewModule } from 'primeng/tabview';
import { PanelModule } from 'primeng/panel';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { OrderFormPageComponent } from './components/order-form-page/order-form-page.component';
import { AgreeContractComponent } from './components/agree-contract/agree-contract.component';
import { AgreeContractModalComponent } from './components/agree-contract-modal/agree-contract-modal.component';
import { CompanySettingsPageComponent } from './components/company-settings-page/company-settings-page.component';
import { CompanyAlertsSettingsComponent } from '../alerts/components/company-alerts-settings/company-alerts-settings.component';
import { AlertSettingsEditorComponent } from '../alerts/components/alert-settings-editor/alert-settings-editor.component';
import { JobRoleListComponent } from '../setting/job-role/components/job-role-list/job-role-list.component';
import { CompanyJobRoleModalComponent } from '../setting/job-role/components/company-job-role-modal/company-job-role-modal.component';
import { CompanyJobRoleEditorComponent } from '../setting/job-role/components/company-job-role-editor/company-job-role-editor.component';
import { BusinessUnitListComponent } from '../setting/business-units/business-unit-list/business-unit-list.component';
import { BusinessUnitEditorComponent } from '../setting/business-units/business-unit-editor/business-unit-editor.component';

import { AlertEmailEditorComponent } from '../alerts/components/alert-email-editor/alert-email-editor.component';
import { CompanySettingsEmailModalComponent } from '../company/components/company-settings-email-modal/company-settings-email-modal.component';
import { BusinessUnitAssignComponent } from '../setting/business-units/business-unit-assign/business-unit-assign.component';
@NgModule({
  declarations: [
    CompanyDashboardComponent,
    CompanyDetailsComponent,
    CompanyDocumentsComponent,
    CompanyDocumentsPageComponent,
    CompanyDocumentDetailsPageComponent,
    CompanyOperativesComponent,
    CompanyDetailsModalComponent,
    CompaniesDocumentsListComponent,
    CompanyOperativeTrainingRecordsComponent,
    CompanyOperativeTrainingRecordsPageComponent,
    CompanyOptInModalComponent,
    OrderFormPageComponent,
    AgreeContractComponent,
    AgreeContractModalComponent,
    CompanySettingsPageComponent,
    CompanyAlertsSettingsComponent,
    AlertSettingsEditorComponent,
    JobRoleListComponent,
    CompanyJobRoleModalComponent,
    CompanyJobRoleEditorComponent,
    BusinessUnitListComponent,
    BusinessUnitEditorComponent,
    AlertEmailEditorComponent,
    CompanySettingsEmailModalComponent,
    BusinessUnitAssignComponent
  ],

  imports: [
    CommonModule,
    CommonsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    TableModule,
    ButtonModule,
    RippleModule,
    InputTextModule,
    RouterModule,
    DocumentsModule,
    SharedModule,
    OperativesModule,
    ObservationModule,
    CardModule,
    PanelModule,
    FormsModule,
    //PrimeIcons,
    InputSwitchModule,
    InputTextareaModule,
    TabViewModule,
  ],

  exports: [
    CompanyDashboardComponent,
    CompanyDetailsComponent,
    CompanyDocumentsComponent,
  ]
})

export class CompanyModule { }
